import { useCallback } from 'react';
import { Folder, FolderHierarchy } from '../types';

export type PathFolder = Pick<Folder, 'id' | 'name'>;

const useGetFolderPath = () => {
  // Recursively searches the FolderHierarchy tree for the target folder.
  const getFolderPath = useCallback(
    (nodes: FolderHierarchy[], targetId: string, path: PathFolder[] = []): PathFolder[] | null => {
      for (const node of nodes) {
        const newPath = [...path, { id: node.id, name: node.name }];
        // If the target folder is found, return the path.
        if (node.id === targetId) {
          return newPath;
        }
        // If the target folder is not found, recursively search the children.
        if (node.children && node.children.length > 0) {
          const result = getFolderPath(node.children, targetId, newPath);
          if (result) return result;
        }
      }
      // If the target folder is not found, return null.
      return null;
    },
    []
  );

  return getFolderPath;
};

export default useGetFolderPath;
